<template>
  <div :class="roleId === 3 ? 'jobGridContainerUser' : 'jobGridContainerAdmin'">
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 20px">
      <div style="display: flex; align-items: center; gap: 10px">
        <p class="jobHistoryTitle">{{ $t('job_history.title') }}</p>
        <img :src="refreshIcon" alt="" @click="refreshData" style="cursor: pointer; margin-bottom: 12px" />
        <button class="filter-button" @click="showFilterModal" style="margin-bottom: 12px">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M7 14H21M3.5 7H24.5M10.5 21H17.5" stroke="var(--primary-color)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <div class="searchBar">
        <button v-if="search" class="resetButton" @click="resetSearch">×</button>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <circle cx="6.5" cy="7.45996" r="5.75" stroke="#8F969B" stroke-width="1.5" />
          <path d="M11 11.96L15 15.96" stroke="#8F969B" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <input style="margin-left: 20px" type="text" class="searchInput" :placeholder="$t('job_history.search.placeholder')" v-model="search" @input="handleSearch" />
      </div>
    </div>

    <div class="tableHeadings" style="width: 100%">
      <!-- <div v-if="writePermission" class="actionsDiv" @click="showActionPopover" style="cursor: pointer">
        <span class="actionsText">{{ $t('job_history.table.actions') }}</span>
      </div> -->
      <!-- <div v-if="writePermission" class="tableVr"></div> -->
      <div v-if="dateRange && dateRange.length === 2" class="date-filter-chip">
        <span class="date-filter-text"> {{ formatDateForDisplay(dateRange[0]) }} - {{ formatDateForDisplay(dateRange[1]) }} </span>
        <button class="date-filter-clear" @click="clearDateFilter">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="#5C656C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
    <div class="tableContainer">
      <div v-if="loading" style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%">
        <div class="spinner-border text-primary spinner-grow-xl" role="status"></div>
      </div>
      <table v-if="!loading" class="customTable">
        <thead class="customTableHeader">
          <tr class="customTableRow">
            <!-- <th class="" style="text-align: center">
              <input type="checkbox" class="customCheckBox" :checked="masterCheckboxSelected" @change="toggleAllCheckboxes" />
            </th> -->
            <th>{{ $t('job_history.table.job_id') }}</th>
            <th v-if="!isBedrock && !isTextract">{{ $t('job_history.table.primary_classification') }}</th>
            <th v-if="!isBedrock && !isTextract">{{ $t('job_history.table.sub_category') }}</th>
            <th>{{ $t('job_history.table.document_types') }}</th>
            <th>{{ $t('job_history.table.document_name') }}</th>
            <th>{{ $t('job_history.table.uploaded_on') }}</th>
            <th>{{ $t('job_history.table.uploaded_by') }}</th>
            <th>{{ $t('job_history.table.status') }}</th>
            <th>{{ $t('job_history.table.vasion_status') }}</th>
            <th style="width: 100px">{{ $t('job_history.table.actions') }}</th>
          </tr>
        </thead>
        <tbody class="customTableBody">
          <tr v-if="jobData.length === 0">
            <td colspan="12" class="no-data-message">
              <div class="no-data-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <h3>{{ $t('job_history.no_data.title') }}</h3>
                <p>{{ $t('job_history.no_data.message') }}</p>
              </div>
            </td>
          </tr>
          <template v-for="job in jobData" :key="job.id">
            <tr class="main-row">
              <!-- <td @click="(event) => handleRowClick(event, job)" style="text-align: center; cursor: pointer" @click.stop>
                <input type="checkbox" class="customCheckBox" :checked="selectedJobs.includes(job?.id)" @change="toggleJobSelection(job?.id)" :disabled="job?.status !== 'completed'" />
              </td> -->
              <td @click="(event) => handleRowClick(event, job)" style="text-align: left; cursor: pointer">
                {{ job?.id }}
              </td>
              <td v-if="!isBedrock && !isTextract" @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                <div class="tooltip-container">
                  <span class="truncate-text">{{ !job?.is_user_selected_classification ? getCategoryNames(job) : getCategoryNamesForUserSelectedClassification(job) || '---' }}</span>
                  <div class="tooltip">
                    {{ !job?.is_user_selected_classification ? getCategoryNames(job) : getCategoryNamesForUserSelectedClassificationTruncated(job) }}
                  </div>
                </div>
              </td>
              <td v-if="!isBedrock && !isTextract" @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                <div class="tooltip-container">
                  <span class="truncate-text">{{ !job?.is_user_selected_classification ? getDepartmentNames(job) : getDepartmentNamesForUserSelectedClassification(job) || '---' }}</span>
                  <div class="tooltip">
                    {{ !job?.is_user_selected_classification ? getDepartmentNames(job) : getDepartmentNamesForUserSelectedClassificationTruncated(job) }}
                  </div>
                </div>
              </td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                <div class="tooltip-container">
                  <span class="truncate-text">{{ !job?.is_user_selected_classification ? formatString(getFullDocumentTypeNames(job)) : formatString(getFullDocumentTypeNamesForUserSelectedClassification(job)) || '---' }}</span>
                  <div class="tooltip">
                    {{ !job?.is_user_selected_classification ? formatString(getFullDocumentTypeNames(job)) : formatString(getFullDocumentTypeNamesForUserSelectedClassificationTruncated(job)) }}
                  </div>
                </div>
              </td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                <div class="tooltip-container">
                  <span class="truncate-text">{{ getFileNames(job) || '---' }}</span>
                  <div class="tooltip">
                    {{ getFullFileNames(job) || '---' }}
                  </div>
                </div>
              </td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">{{ formatDate(job?.created_at).date }}<br />{{ formatDate(job?.created_at).time }}</td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" :title="getCreatedBy(job)">
                {{ getCreatedBy(job) }}
              </td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">
                <StatusBadge :status="job?.status" />
              </td>
              <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">
                <StatusBadge :status="job?.vasion_status" />
              </td>
              <td style="text-align: center">
                <div class="actions-menu" @click.stop>
                  <button v-if="writePermission" class="actions-button" @click="showActionsMenu($event, job, job?.selectedItem, job?.selectedItemManual)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="6" r="2" fill="var(--primary-color)" />
                      <circle cx="12" cy="12" r="2" fill="var(--primary-color)" />
                      <circle cx="12" cy="18" r="2" fill="var(--primary-color)" />
                    </svg>
                  </button>
                  <div v-if="showActionsDropdown && selectedJob?.id === job?.id" class="actions-dropdown">
                    <div class="action-item" v-if="job?.selectedItem === 'Pending' && job?.status === 'pending'" @click="handleStartJob(job, false)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>{{ $t('job_history.actions.start_job') }}</span>
                    </div>
                    <div class="action-item" v-if="job?.selectedItem !== 'Pending'" @click="handleView(job, false, job?.selectedItem, job?.selectedItemManual)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21.544 11.045C21.848 11.471 22 11.685 22 12C22 12.316 21.848 12.529 21.544 12.955C20.178 14.871 16.689 19 12 19C7.31 19 3.822 14.87 2.456 12.955C2.152 12.529 2 12.315 2 12C2 11.684 2.152 11.471 2.456 11.045C3.822 9.129 7.311 5 12 5C16.69 5 20.178 9.13 21.544 11.045Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>{{ $t('job_history.actions.view') }}</span>
                    </div>
                    <div v-if="job?.selectedItem !== 'Pending' && job?.selectedItem !== 'Completed' && job?.selectedItemManual !== 'Completed' && job?.selectedItem !== 'Failed' && job?.selectedItemManual !== 'Failed'" class="action-item" @click="handleView(job, true)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M2.5 13.833L6 17.5L7.024 16.427M16.5 6.5L10.437 12.852M7.5 13.833L11 17.5L21.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>{{ $t('job_history.actions.manual_validations') }}</span>
                    </div>
                    <!-- <div v-if="job?.selectedItem === 'Failed' || job?.selectedItemManual === 'Failed'" class="action-item" @click="handleView(job, true)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M2.5 13.833L6 17.5L7.024 16.427M16.5 6.5L10.437 12.852M7.5 13.833L11 17.5L21.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>{{ $t('job_history.actions.manual_validations') }}</span>
                    </div> -->
                    <!-- <div v-if="getApiStatus() !== 'failed' && job?.selectedItem !== 'Pending' && job?.selectedItemManual !== 'Pending' && job?.selectedItem !== 'Completed' && job?.selectedItemManual !== 'Completed'" class="action-item" @click="handleStartWorkflow(job)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21.75 12C21.75 14.5859 20.7228 17.0658 18.8943 18.8943C17.0658 20.7228 14.5859 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C14.5859 2.25 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12Z" stroke="currentColor" stroke-width="1.2" />
                        <path d="M16.5 12L9.75 7.5V16.5L16.5 12Z" stroke="currentColor" />
                      </svg>
                      <span>{{ $t('job_history.actions.start_workflow') }}</span>
                    </div>
                    <div v-if="getApiStatus() !== 'failed' && job?.selectedItem !== 'Pending' && job?.selectedItemManual !== 'Pending' && job?.selectedItem !== 'Completed' && job?.selectedItemManual !== 'Completed'" class="action-item" @click="handleSendToVasion(job)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g clip-path="url(#clip0_789_2107)">
                          <path d="M12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V11H6C5.22 11 4.195 11.302 3.38 11.964C2.598 12.6 2 13.572 2 15C2 16.414 2.615 17.388 3.42 18.032C4.256 18.702 5.286 19 6 19C6.973 19 8.239 18.985 9.263 18.479C9.748 18.239 10.163 17.894 10.466 17.382C10.772 16.865 11 16.112 11 15V13.914L9.5 15.414L8.086 14L12 10.086L15.914 14L14.5 15.414L13 13.914V15C13 16.387 12.714 17.51 12.188 18.4C11.7066 19.2108 10.9971 19.8619 10.148 20.272C8.674 21 6.979 21 6.056 21H6C4.832 21 3.362 20.548 2.17 19.593C0.943 18.613 0 17.086 0 15C0 12.928 0.903 11.4 2.12 10.411C2.95554 9.73913 3.94538 9.28614 5 9.093V9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9V9.093C20.0546 9.28614 21.0445 9.73913 21.88 10.411C23.099 11.401 24 12.928 24 15C24 17.076 23.093 18.614 21.795 19.607C20.529 20.575 18.93 21 17.5 21H13.5V19H17.5C18.57 19 19.721 18.675 20.58 18.018C21.407 17.386 22 16.424 22 15C22 13.572 21.402 12.6 20.62 11.964C19.804 11.302 18.78 11 18 11H17V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z" fill="currentColor" stroke="white" stroke-width="0.8" />
                        </g>
                        <defs>
                          <clipPath id="clip0_789_2107">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>{{ $t('job_history.actions.send_to_vasion') }}</span>
                    </div> -->
                    <div v-if="job?.selectedItem === 'Failed' || job?.selectedItemManual === 'Failed'" class="action-item" @click="handleRetry(job)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="17 1 21 5 17 9"></polyline>
                        <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                        <polyline points="7 23 3 19 7 15"></polyline>
                        <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                      </svg>
                      <span>{{ $t('job_history.actions.retry') }}</span>
                    </div>
                    <div class="action-item" @click="handleDelete(job)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                      <span>{{ $t('job_history.actions.delete') }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-if="showPopover" class="popover-overlay" @click="closePopover">
      <div class="popover-menu" @click.stop :style="{ top: popoverPosition.top, left: popoverPosition.left }">
        <div
          class="popover-item"
          :class="{
            'popover-item-disabled': !shouldShowAction('startWorkflow'),
          }"
          @click="shouldShowAction('startWorkflow') ? handleStartWorkflow() : null"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{ 'svg-disabled': !shouldShowAction('startWorkflow') }">
            <path d="M21.75 12C21.75 14.5859 20.7228 17.0658 18.8943 18.8943C17.0658 20.7228 14.5859 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C14.5859 2.25 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12Z" stroke="currentColor" stroke-width="1.2" />
            <path d="M16.5 12L9.75 7.5V16.5L16.5 12Z" stroke="currentColor" />
          </svg>
          <span>{{ $t('job_history.actions.start_workflow') }}</span>
        </div>
        <div
          class="popover-item"
          :class="{
            'popover-item-disabled': !shouldShowAction('sendToVasion'),
          }"
          @click="shouldShowAction('sendToVasion') ? handleSendToVasion() : null"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{ 'svg-disabled': !shouldShowAction('sendToVasion') }">
            <g clip-path="url(#clip0_789_2107)">
              <path d="M12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V11H6C5.22 11 4.195 11.302 3.38 11.964C2.598 12.6 2 13.572 2 15C2 16.414 2.615 17.388 3.42 18.032C4.256 18.702 5.286 19 6 19C6.973 19 8.239 18.985 9.263 18.479C9.748 18.239 10.163 17.894 10.466 17.382C10.772 16.865 11 16.112 11 15V13.914L9.5 15.414L8.086 14L12 10.086L15.914 14L14.5 15.414L13 13.914V15C13 16.387 12.714 17.51 12.188 18.4C11.7066 19.2108 10.9971 19.8619 10.148 20.272C8.674 21 6.979 21 6.056 21H6C4.832 21 3.362 20.548 2.17 19.593C0.943 18.613 0 17.086 0 15C0 12.928 0.903 11.4 2.12 10.411C2.95554 9.73913 3.94538 9.28614 5 9.093V9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9V9.093C20.0546 9.28614 21.0445 9.73913 21.88 10.411C23.099 11.401 24 12.928 24 15C24 17.076 23.093 18.614 21.795 19.607C20.529 20.575 18.93 21 17.5 21H13.5V19H17.5C18.57 19 19.721 18.675 20.58 18.018C21.407 17.386 22 16.424 22 15C22 13.572 21.402 12.6 20.62 11.964C19.804 11.302 18.78 11 18 11H17V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z" fill="currentColor" stroke="white" stroke-width="0.8" />
            </g>
            <defs>
              <clipPath id="clip0_789_2107">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>{{ $t('job_history.actions.send_to_vasion') }}</span>
        </div>
      </div>
    </div>
    <div v-if="showFilter" class="filter-modal-overlay">
      <div class="filter-modal">
        <div class="filter-modal-header">
          <h2 class="apply-filters-title">{{ $t('job_history.filter.title') }}</h2>
          <button class="close-button" @click="closeFilterModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
              <path d="M5.48633 4.66602L16.2882 16.3319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.48527 16.3319L16.2871 4.66602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="filter-content">
          <div class="filter-section">
            <label class="filter-label">{{ $t('job_history.filter.date_range') }}</label>
            <div class="date-input-container">
              <Datepicker v-model="dateRange" range :format="dateFormat" placeholder="MM/DD/YY - MM/DD/YY" :enable-time-picker="false" :clearable="true" class="date-picker" :range-separator="' - '" :multi-calendars="true" :auto-apply="true" text-input :calendar-icon="false" />
            </div>
          </div>
          <div class="filter-actions">
            <button class="cancel-button" @click="closeFilterModalNew">{{ $t('common.cancel') }}</button>
            <button class="apply-button" @click="applyFilter">{{ $t('dashboard.apply_filter') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <VasionConfirmationModal :show="showVasionConfirmModal" @close="handleVasionConfirmClose" @confirm="handleVasionConfirm" />
  <DeleteConfirmationModal :show="showDeleteConfirmModal" @close="handleDeleteConfirmClose" @confirm="confirmDelete" />
  <JobDetailsModal :show="showJobDetailsModal" :job="selectedJobForDetails" :job-details="selectedJobForDetails ? getAccordionDetails(selectedJobForDetails) : []" @close="handleJobDetailsClose" @view="handleJobDetailsView" @start-workflow="handleJobDetailsStartWorkflow" @send-to-vasion="handleJobDetailsSendToVasion" @viewJobHistory="handleViewJobHistory" :selectedItem="selectedItem" :selectedItemManual="selectedItemManual" :isBedrock="isBedrock" :isTextract="isTextract" from="dashboard" />
  <DocumentHistory :show="!!selectedJobForHistory" :job-id="selectedJobForHistory" :selected-result-document="selectedResultDocument" @close="handleDocumentHistoryClose" />
</template>
<script>
import StatusBadge from '../../components/StatusBadge.vue'
import { get, post, deleteJob, put } from '../../utils/api.js'
import { showToast } from '@/utils/toast'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import VasionConfirmationModal from '@/components/VasionConfirmationModal/VasionConfirmationModal.vue'
import DeleteConfirmationModal from '@/components/DeleteConfirmationModal/DeleteConfirmationModal.vue'
import JobDetailsModal from '@/components/JobDetailsModal/JobDetailsModal.vue'
import DocumentHistory from '@/components/DocumentHistory/DocumentHistory.vue'
import arrowDownIcon from '@/assets/arrowDown.png'
import vectorIcon from '@/assets/Vector.png'
import hideSidebarIcon from '@/assets/hideSidebar.png'
import checkDoneIcon from '@/assets/checkDone.png'
import clockIcon from '@/assets/clock.png'
import refreshIcon from '@/assets/refresh.png'
import backwardIcon from '@/assets/backward.svg'
import forwardIcon from '@/assets/forward.svg'
import { isAiMethodBedrock, isAiMethodTextract } from '@/utils/tenantUtils.js'
export default {
  components: {
    Datepicker,
    StatusBadge,
    VasionConfirmationModal,
    DeleteConfirmationModal,
    JobDetailsModal,
    DocumentHistory,
  },
  props: {
    roleId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      readPermission: false,
      writePermission: false,
      search: '',
      debounceTimeout: null,
      is_manually_validated: 0,
      isOpen: true,
      isSideBarOpen: true,
      isOpenManual: true,
      selectedItem: '',
      selectedItemManual: '',
      jobItems: ['Pending', 'Completed', 'Failed'],
      jobItemsManual: ['Pending', 'Completed', 'Failed'],
      jobData: [],
      loading: false,
      page: 1,
      pageSize: 15,
      total: 0,
      totalPages: 1,
      pageSizeOptions: [10, 20, 50, 100],
      showPageSizeDropdown: false,
      showPopover: false,
      selectedJob: null,
      popoverPosition: {
        top: '20px',
        left: '0px',
      },
      masterCheckboxSelected: false,
      selectedJobs: [],
      showFilter: false,
      dateRange: [],
      dateFormat: 'MM/dd/yyyy',
      expandedRows: [],
      showActionsDropdown: false,
      showVasionConfirmModal: false,
      pendingVasionAction: null,
      showDeleteConfirmModal: false,
      jobToDelete: null,
      jobCounts: {
        jobsPending: 0,
        jobsCompleted: 0,
        jobsFailed: 0,
        jobsTotal: 0,
        ManualPending: 0,
        ManualCompleted: 0,
        ManualFailed: 0,
        ManualTotal: 0,
      },
      showJobDetailsModal: false,
      selectedJobForDetails: null,
      selectedJobForHistory: null,
      selectedResultDocument: null,
      arrowDownIcon,
      vectorIcon,
      hideSidebarIcon,
      checkDoneIcon,
      clockIcon,
      refreshIcon,
      backwardIcon,
      forwardIcon,
    }
  },
  mounted() {
    document.title = 'Job History'
    this.checkPermissions()
    this.fetchJobs()
    // Add event listener for clicking outside
    document.addEventListener('click', this.handleClickOutside)
  },
  computed: {
    isBedrock() {
      return isAiMethodBedrock()
    },
    isTextract() {
      return isAiMethodTextract()
    },
  },
  beforeUnmount() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = permissions.some((p) => p.object_name === 'JOB_HISTORY_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'JOB_HISTORY_WR' && p.is_active)
    },
    formatString(input) {
      // Split only on the first two underscores
      if (!input) return ''
      const parts = input.split('_')

      // If fewer than 3 parts, nothing to format
      if (parts.length < 3) return input

      // Join everything after the second underscore
      const rest = parts.slice(2).join('_')

      // Replace _ and - with space
      return rest.replace(/[_-]/g, ' ')
    },
    handleClickOutside(event) {
      // Check if click is outside the actions menu and button
      const actionsMenu = event.target.closest('.actions-dropdown')
      const actionsButton = event.target.closest('.actions-button')
      const pageSizeDropdown = event.target.closest('.pageSizeDropdown')
      const pageSizeButton = event.target.closest('.pageDiv')
      const filterModal = event.target.closest('.filter-modal')
      const filterButton = event.target.closest('.filter-button')

      if (this.showActionsDropdown && !actionsMenu && !actionsButton) {
        this.showActionsDropdown = false
      }

      if (this.showPageSizeDropdown && !pageSizeDropdown && !pageSizeButton) {
        this.showPageSizeDropdown = false
      }

      if (this.showFilter && !filterModal && !filterButton) {
        this.closeFilterModal()
      }
    },
    updateUrl() {
      const query = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
        is_manually_validated: this.is_manually_validated,
      }
      if (this.dateRange.length > 0) {
        query.dateRange = JSON.stringify(this.dateRange)
      }

      this.$router.replace({ query })
    },
    getApiStatus() {
      return 'success' // or implement your actual API status check
    },
    async fetchJobs() {
      try {
        this.loading = true
        let url = `/v1/mx-jobs?page=${this.page}&pageSize=${this.pageSize}`

        if (this.search) {
          url += `&search=${encodeURIComponent(this.search)}`
        }

        const from_date = this.formatDateForApi(this.dateRange[0])
        const to_date = this.formatDateForApi(this.dateRange[1])
        if (from_date && to_date) {
          url += `&from_date=${from_date}&to_date=${to_date}`
        }

        const response = await get(url)
        if (response?.status === 200) {
          const data = response.data
          this.jobData = (data.data || []).map((job) => {
            let selectedItem = 'Pending'
            let selectedItemManual = 'Pending'
            if (job.status === 'completed' && job.vasion_status === 'completed') {
              if (job.is_manually_validated) {
                selectedItemManual = 'Completed'
                selectedItem = ''
              } else {
                selectedItem = 'Completed'
                selectedItemManual = ''
              }
            } else if ((job?.status == 'completed' || job?.status == 'pending' || job?.status == 'inprogress') && (job?.vasion_status == 'partial' || job?.vasion_status == 'pending' || job?.vasion_status == 'NA')) {
              if (job.is_manually_validated) {
                selectedItemManual = 'Pending'
                selectedItem = ''
              } else {
                selectedItem = 'Pending'
                selectedItemManual = ''
              }
            } else {
              if (job.is_manually_validated) {
                selectedItemManual = 'Failed'
                selectedItem = ''
              } else {
                selectedItem = 'Failed'
                selectedItemManual = ''
              }
            }
            return {
              ...job,
              selectedItem,
              selectedItemManual,
            }
          })
          this.total = data.total
          this.totalPages = Math.ceil(this.total / this.pageSize)
          await this.fetchJobCounts()
        } else {
          this.jobData = []
        }
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to fetch jobs',
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    selectFilter(option) {
      this.selectedFilter = option
      this.setDateRangeByFilter(option)
      this.fetchJobs()
    },
    setDateRangeByFilter(option) {
      const end = new Date()
      let start = new Date()

      switch (option) {
        case 'Day':
          start.setDate(end.getDate() - 1)
          break
        case 'Week':
          start.setDate(end.getDate() - 7)
          break
        case 'Month':
          start.setMonth(end.getMonth() - 1)
          break
        case 'Year':
          start.setFullYear(end.getFullYear() - 1)
          break
      }

      this.dateRange = [start, end]
    },
    formatDateForApi(date) {
      if (!date) return null
      const d = new Date(date)
      const formattedDate = d.toISOString().split('T')[0] // Returns YYYY-MM-DD format
      return formattedDate
    },

    async refreshData() {
      await this.fetchJobs(this.getApiStatus())
    },
    async goToFirstPage() {
      if (this.page !== 1) {
        this.page = 1
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToLastPage() {
      if (this.page !== this.totalPages) {
        this.page = this.totalPages
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToNextPage() {
      if (this.page < this.totalPages) {
        this.page++
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToPreviousPage() {
      if (this.page > 1) {
        this.page--
        this.updateUrl()
        await this.refreshData()
      }
    },
    async selectPageSize(size) {
      this.pageSize = size
      this.page = 1
      this.showPageSizeDropdown = false
      this.updateUrl()
      await this.refreshData()
    },
    async applyFilter() {
      this.page = 1
      await this.refreshData()
      this.closeFilterModal()
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    toggleSideBaDropdown() {
      this.isSideBarOpen = !this.isSideBarOpen
    },
    toggleDropdownManual() {
      this.isOpenManual = !this.isOpenManual
    },
    formatDate(dateStr) {
      const dateObj = new Date(dateStr)
      const dateOptions = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }
      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }
      const date = dateObj.toLocaleDateString('en-US', dateOptions)
      const time = dateObj.toLocaleTimeString('en-US', timeOptions)
      return { date, time }
    },
    async handleView(job, isManual, selectedItem, selectedItemManual) {
      this.selectedItem = selectedItem
      this.selectedItemManual = selectedItemManual
      const tenantName = localStorage.getItem('url_name')
      this.$router.push({
        name: 'view-document',
        params: { tenantName },
        query: { jobId: job?.id, isManual, from: 'dashboard' },
      })
    },
    async handleRowClick(event, job) {
      this.selectedItem = job?.selectedItem
      this.selectedItemManual = job?.selectedItemManual
      if (event.target.closest('td:first-child')) {
        return
      }
      this.selectedJobForDetails = job
      this.showJobDetailsModal = true
    },
    togglePageSizeDropdown(event) {
      if (event) {
        event.stopPropagation()
      }
      this.showPageSizeDropdown = !this.showPageSizeDropdown
    },
    getFileNames(job) {
      if (!job?.mx_job_files || job?.mx_job_files?.length === 0) return '---'
      const uniqueFileNames = [...new Set(job?.mx_job_files?.map((file) => file.file_name).filter(Boolean))].join(', ')
      if (uniqueFileNames.length <= 20) return uniqueFileNames
      return uniqueFileNames.substring(0, 20) + '...'
    },
    getFullDocumentTypeNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const uniqueDepartments = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.document_type?.document_type_name).filter(Boolean))].join(', ')
      return uniqueDepartments
    },
    getFullDocumentTypeNamesForUserSelectedClassification(job) {
      if (!job?.document_type || job.document_type.length === 0) return '---'
      const uniqueDepartments = job?.document_type?.document_type_display_name
      return uniqueDepartments
    },
    getFullDocumentTypeNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.document_type || job.document_type.length === 0) return '---'
      const uniqueDepartments = job?.document_type?.document_type_display_name
      if (uniqueDepartments?.length <= 20) return uniqueDepartments
      return uniqueDepartments?.substring(0, 20) + '...'
    },
    getCreatedBy(job) {
      return `${job?.updated_by_user?.first_name} ${job?.updated_by_user?.last_name}`
    },
    getDepartmentNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const uniqueDepartments = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.department?.department_name).filter(Boolean))].join(', ')
      if (uniqueDepartments.length <= 20) return uniqueDepartments
      return uniqueDepartments.substring(0, 20) + '...'
    },
    getDepartmentNamesForUserSelectedClassification(job) {
      if (!job?.sub_category || job.sub_category.length === 0) return '---'
      const uniqueDepartments = job?.sub_category?.department_display_name
      return uniqueDepartments
    },
    getDepartmentNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.sub_category || job.sub_category.length === 0) return '---'
      const uniqueDepartments = job?.sub_category?.department_display_name
      if (uniqueDepartments?.length <= 20) return uniqueDepartments
      return uniqueDepartments?.substring(0, 20) + '...'
    },
    getCategoryNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const categoryNames = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.category?.category_name).filter(Boolean))].join(', ')
      if (categoryNames.length <= 20) return categoryNames
      return categoryNames.substring(0, 20) + '...'
    },
    getCategoryNamesForUserSelectedClassification(job) {
      if (!job?.primary_classification || job.primary_classification.length === 0) return '---'
      const categoryNames = job?.primary_classification?.category_display_name
      return categoryNames
    },
    getCategoryNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.primary_classification || job.primary_classification.length === 0) return '---'
      const categoryNames = job?.primary_classification?.category_display_name
      if (categoryNames?.length <= 20) return categoryNames

      return categoryNames?.substring(0, 20) + '...'
    },
    getFullFileNames(job) {
      if (!job?.mx_job_result_documents || job?.mx_job_result_documents.length === 0) return '---'
      return [...new Set(job?.mx_job_result_documents.map((file) => file.file_name).filter(Boolean))].join(', ')
    },
    getFullFileNamesAccordian(job, detail) {
      const jobFileId = detail.jobFileId

      if (!job?.mx_job_result_documents || job?.mx_job_result_documents.length === 0) {
        return '---'
      }

      const result_document = job?.mx_job_result_documents?.find((file) => file.mx_job_file_id === jobFileId)
      return result_document?.file_name || '---'
    },
    getFullDepartmentNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const result = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.department?.department_name).filter(Boolean))].join(', ')
      if (result) {
        return '...'
      } else {
        return result
      }
    },
    showPopoverMenu(event, job) {
      this.selectedJob = job
      this.showPopover = true
      this.popoverPosition = {
        top: `${event.clientY}px`,
        left: `${event.clientX}px`,
      }
    },
    closePopover() {
      this.showPopover = false
      this.selectedJob = null
    },
    handleValidateManually() {
      this.showActionsDropdown = false
    },
    async handleStartWorkflow(job) {
      if (this.selectedJobs.length === 0 && !job) {
        showToast({
          title: 'Operation Failed',
          message: 'Please select at least one job',
          type: 'error',
        })
        return
      }

      // Check if any selected job has completed Vasion status
      const hasCompletedVasionStatus = job
        ? job?.vasion_status?.toLowerCase() === 'completed'
        : this.selectedJobs.some((jobId) => {
            const job = this.jobData.find((j) => j?.job?.id === jobId)
            return job?.vasion_status?.toLowerCase() === 'completed'
          })

      if (hasCompletedVasionStatus) {
        this.pendingVasionAction = {
          type: 'workflow',
          jobs: job ? [job?.id] : this.selectedJobs,
        }
        this.showVasionConfirmModal = true
        return
      }

      await this.executeStartWorkflow()
    },
    async executeStartWorkflow() {
      try {
        const jobIds = this.selectedJob ? [this.selectedJob?.id] : this.selectedJobs
        const payload = jobIds.map((jobId) => ({
          job_id: jobId,
          save_to_vasion: false,
        }))
        await post('/v1/vasion/saveall-document', payload)
        showToast({
          title: 'Operation Successful',
          message: 'Workflow started successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        await this.refreshData()
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to start workflow',
          type: 'error',
        })
      }
    },
    async handleSendToVasion(job) {
      if (this.selectedJobs.length === 0 && !job) {
        showToast({
          title: 'Operation Failed',
          message: 'Please select at least one job',
          type: 'error',
        })
        return
      }

      // Check if any selected job has completed Vasion status
      const hasCompletedVasionStatus = job
        ? job?.vasion_status?.toLowerCase() === 'completed'
        : this.selectedJobs.some((jobId) => {
            const job = this.jobData.find((j) => j?.job?.id === jobId)
            return job?.vasion_status?.toLowerCase() === 'completed'
          })
      if (hasCompletedVasionStatus) {
        this.pendingVasionAction = {
          type: 'vasion',
          jobs: job ? [job?.id] : this.selectedJobs,
        }
        this.showVasionConfirmModal = true
        return
      }

      await this.executeSendToVasion()
    },
    async executeSendToVasion() {
      try {
        const jobIds = this.selectedJob ? [this.selectedJob?.id] : this.selectedJobs
        const payload = jobIds.map((jobId) => ({
          job_id: jobId,
          save_to_vasion: true,
        }))
        await post('/v1/vasion/saveall-document', payload)
        showToast({
          title: 'Operation Successful',
          message: 'Documents sent to Vasion successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        await this.refreshData()
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to send to Vasion',
          type: 'error',
        })
      }
    },
    handleVasionConfirmClose() {
      this.showVasionConfirmModal = false
      this.pendingVasionAction = null
    },
    async handleVasionConfirm() {
      if (this.pendingVasionAction?.type === 'workflow') {
        await this.executeStartWorkflow()
      } else if (this.pendingVasionAction?.type === 'vasion') {
        await this.executeSendToVasion()
      }
      this.handleVasionConfirmClose()
    },
    showActionPopover(event) {
      this.showPopover = true
      const rect = event.target.getBoundingClientRect()
      this.popoverPosition = {
        top: `${rect.bottom + 5}px`,
        left: `${rect.left}px`,
      }
    },
    toggleAllCheckboxes(event) {
      this.masterCheckboxSelected = event.target.checked
      if (this.masterCheckboxSelected) {
        this.selectedJobs = this.jobData
          .filter((job) => job?.status?.toLowerCase() === 'completed')
          .map((job) => job?.id)
          .filter(Boolean)
      } else {
        this.selectedJobs = []
      }
    },
    toggleJobSelection(jobId) {
      if (!jobId) return
      const index = this.selectedJobs.indexOf(jobId)
      if (index === -1) {
        this.selectedJobs.push(jobId)
      } else {
        this.selectedJobs.splice(index, 1)
      }
      this.masterCheckboxSelected = this.selectedJobs.length === this.jobData.length
    },
    shouldShowAction(actionType) {
      if (this.selectedJobs.length === 0) {
        return false
      }
      const isCompleteOrFailed = ['Completed', 'Failed', 'Pending'].includes(this.selectedItem) || ['Completed', 'Failed', 'Pending'].includes(this.selectedItemManual)
      const singleSelection = this.selectedJobs.length === 1
      const isCompleted = this.selectedItem === 'Completed' || this.selectedItem === 'Pending' || this.selectedItemManual === 'Completed' || this.selectedItemManual === 'Pending'
      switch (actionType) {
        case 'view':
          return isCompleteOrFailed && singleSelection
        case 'validateManually':
          return ['Completed', 'Failed', 'Pending'].includes(this.selectedItemManual) && singleSelection
        case 'startWorkflow':
          return isCompleted
        case 'sendToVasion':
          return isCompleted
        default:
          return false
      }
    },
    showFilterModal() {
      this.showFilter = true
    },
    closeFilterModal() {
      this.showFilter = false
      this.selectedFilter = ''

      // this.closeFilterModalNew()
    },
    closeFilterModalNew() {
      this.showFilter = false
    },
    toggleAccordion() {
      // This method is no longer needed
    },
    showActionsMenu(event, job, selectedItem, selectedItemManual) {
      event.stopPropagation()
      this.selectedItem = selectedItem
      this.selectedItemManual = selectedItemManual
      this.selectedJob = job
      this.showActionsDropdown = true
    },
    getAccordionDetails(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) {
        return []
      }

      // Group details by job file and document type combination
      const groupedDetails = job.mx_file_page_textract_details.reduce((acc, item, index) => {
        const typeId = item.tenant_document_type_id
        const jobFileId = item.mx_job_file_id
        // const groupKey = `${jobFileId}_${typeId}` // Create a unique key combining both IDs
        const mx_job_result_document_id = item.mx_job_result_document_id
        const groupKey = `${mx_job_result_document_id}_`
        if (!acc[groupKey]) {
          // Create new group for unique document type and job file combination
          acc[groupKey] = {
            category: item.tenant_document_type?.category?.category_name || '---',
            department: item.tenant_document_type?.department?.department_name || '---',
            documentType: item.tenant_document_type?.document_type?.document_type_name || '---',
            jobFileId: jobFileId,
            resultDocument: job?.mx_job_result_documents,
            resultDocumentSelected: job?.mx_job_result_documents?.find((doc) => doc.mx_job_file_id === Number(item.mx_job_file_id) && doc.tenant_document_type_id?.toString() === item.tenant_document_type_id?.toString()),
            typeId: typeId,
            mx_job_result_document_id: item.mx_job_result_document_id,
          }
        }

        return acc
      }, {})

      // Convert grouped object to array
      return Object.values(groupedDetails)
    },
    getVasionStatusForDetail(detail) {
      if (!detail?.resultDocument || !detail?.jobFileId) return '---'
      const matchingDoc = detail.resultDocument.find((doc) => doc.mx_job_file_id === detail.jobFileId)
      return matchingDoc?.vasion_status || '---'
    },
    async handleRetry(job) {
      try {
        await put(`/v1/mx-jobs/retry/${job?.id}`)
        showToast({
          title: 'Operation Successful',
          message: 'Job retry initiated successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        await this.refreshData()
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to retry job',
          type: 'error',
        })
      }
    },
    async handleDelete(job) {
      this.jobToDelete = job
      this.showDeleteConfirmModal = true
    },
    async confirmDelete() {
      try {
        await deleteJob(this.jobToDelete?.id)
        showToast({
          title: 'Operation Successful',
          message: 'Job deleted successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        this.showDeleteConfirmModal = false
        this.jobToDelete = null
        await this.refreshData()
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to delete job',
          type: 'error',
        })
      }
    },
    handleDeleteConfirmClose() {
      this.showDeleteConfirmModal = false
      this.jobToDelete = null
    },
    async fetchJobCounts() {
      try {
        const response = await get('/v1/mx-jobs/counts')
        if (response?.status === 200) {
          const data = response.data

          // Get first and second keys
          const keys = Object.keys(data)
          const firstKey = keys[0]
          const secondKey = keys[1]

          // Update values based on first key
          if (firstKey === '1') {
            // Update Manual values
            this.jobCounts.ManualPending = data['1']?.pending || 0
            this.jobCounts.ManualCompleted = data['1']?.completed || 0
            this.jobCounts.ManualFailed = data['1']?.failed || 0
            this.jobCounts.ManualTotal = (data['1']?.pending || 0) + (data['1']?.completed || 0) + (data['1']?.failed || 0)
          } else if (firstKey === '0') {
            // Update Jobs values
            this.jobCounts.jobsPending = data['0']?.pending || 0
            this.jobCounts.jobsCompleted = data['0']?.completed || 0
            this.jobCounts.jobsFailed = data['0']?.failed || 0
            this.jobCounts.jobsTotal = (data['0']?.pending || 0) + (data['0']?.completed || 0) + (data['0']?.failed || 0)
          }

          // Update values based on second key
          if (secondKey === '1') {
            // Update Manual values
            this.jobCounts.ManualPending = data['1']?.pending || 0
            this.jobCounts.ManualCompleted = data['1']?.completed || 0
            this.jobCounts.ManualFailed = data['1']?.failed || 0
            this.jobCounts.ManualTotal = (data['1']?.pending || 0) + (data['1']?.completed || 0) + (data['1']?.failed || 0)
          } else if (secondKey === '0') {
            // Update Jobs values
            this.jobCounts.jobsPending = data['0']?.pending || 0
            this.jobCounts.jobsCompleted = data['0']?.completed || 0
            this.jobCounts.jobsFailed = data['0']?.failed || 0
            this.jobCounts.jobsTotal = (data['0']?.pending || 0) + (data['0']?.completed || 0) + (data['0']?.failed || 0)
          }
        }
      } catch (error) {}
    },
    getJobCount(item, type) {
      if (type === 'jobs') {
        if (item === 'Pending') {
          return this.jobCounts.jobsPending
        } else if (item === 'Completed') {
          return this.jobCounts.jobsCompleted
        } else if (item === 'Failed') {
          return this.jobCounts.jobsFailed
        }
      } else {
        if (item === 'Pending') {
          return this.jobCounts.ManualPending
        } else if (item === 'Completed') {
          return this.jobCounts.ManualCompleted
        } else if (item === 'Failed') {
          return this.jobCounts.ManualFailed
        }
      }
      // // if (count > 999999) return (count / 1000000).toFixed(1) + 'M'
      // // if (count > 9999) return (count / 1000).toFixed(1) + 'K'
      // return count
    },
    getCountClass(item) {
      switch (item?.toLowerCase()) {
        case 'pending':
          return 'count-pending'
        case 'completed':
          return 'count-completed'
        case 'failed':
          return 'count-failed'
        default:
          return ''
      }
    },
    handleJobDetailsClose() {
      this.showJobDetailsModal = false
      this.selectedJobForDetails = null
    },
    handleJobDetailsView({ detail, isManual, jobId }) {
      this.$router.push({
        path: '/view-document',
        query: { jobId, isManual, from: 'dashboard' },
      })
    },
    async handleJobDetailsStartWorkflow(detail) {
      if (detail?.resultDocument?.some((doc) => doc.vasion_status?.toLowerCase() === 'completed')) {
        this.pendingVasionAction = {
          type: 'workflow',
          jobs: [this.selectedJobForDetails?.job?.id],
          detail,
        }
        this.showVasionConfirmModal = true
        return
      }
      await this.executeStartWorkflow(detail)
    },
    async handleJobDetailsSendToVasion(detail) {
      if (detail?.resultDocument?.some((doc) => doc.vasion_status?.toLowerCase() === 'completed')) {
        this.pendingVasionAction = {
          type: 'vasion',
          jobs: [this.selectedJobForDetails?.job?.id],
          detail,
        }
        this.showVasionConfirmModal = true
        return
      }
      await this.executeSendToVasion(detail)
    },
    handleSearch() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.fetchJobs(this.getApiStatus())
      }, 300)
    },
    resetSearch() {
      this.search = ''
      this.fetchJobs(this.getApiStatus())
    },
    async handleStartJob(job, isManual) {
      try {
        const res = await put(`/v1/mx-jobs/${job?.id}`, {})
        if (res?.status === 200) {
          showToast({
            title: 'Operation Successful',
            message: 'Job started successfully',
            type: 'success',
          })
          this.showActionsDropdown = false
          await this.refreshData()
        }
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to start job',
          type: 'error',
        })
      }
    },
    formatDateForDisplay(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    },
    clearDateFilter() {
      this.dateRange = []
      this.fetchJobs(this.getApiStatus())
    },
    handleViewJobHistory(data) {
      this.selectedJobForHistory = data.jobId
      this.selectedResultDocument = data.selectedResultDocument
      this.showJobDetailsModal = false // Close the job details modal
    },
    handleDocumentHistoryClose() {
      this.selectedJobForHistory = null
      this.selectedResultDocument = null
    },
  },
}
</script>

<style scoped>
@import '@/styles/jobHistory.css';

.tableContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  overflow-y: auto;
}

.customTable {
  width: 100%;
}

/* Column width specifications */
.customTable th:first-child,
.customTable td:first-child {
  width: 100px;
  /* Checkbox column */
}

.customTable th:nth-child(2),
.customTable td:nth-child(2) {
  /* width: 100px; */
  /* Job ID column */
}

.customTable th:last-child,
.customTable td:last-child {
  /* width: 80px; */
  /* Actions column */
}

.arrowDownIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.arrowDownIcon.rotated {
  transform: rotate(-180deg);
}

.rotated {
  transform: rotate(-180deg);
}

.pageSizeDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
  width: 100%;
}

.pageSizeDropdown li {
  padding: 8px 12px;
  cursor: pointer;
}

.pageSizeDropdown li:hover {
  background-color: #f5f5f5;
}

.pageDiv {
  position: relative;
  cursor: pointer;
}

img[src*='refresh.png'],
img[src*='backward.svg'],
img[src*='forward.svg'] {
  cursor: pointer;
}

.pageDiv {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  background: #fff;
}

.popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 1000;
}

.popover-menu {
  position: absolute;
  display: flex;
  width: 225px;
  height: 122px;
  padding: 14px 24px 14px 11px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 4px 13.1px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}

.popover-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: capitalize;
}

.popover-item:hover {
  background-color: #f5f5f5;
}

.popover-item svg {
  flex-shrink: 0;
}

.popover-item span {
  white-space: nowrap;
}

.actions-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.action-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.actionsText {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: uppercase;
}

.popover-item-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  color: #999 !important;
}

.popover-item-disabled svg {
  opacity: 0.5;
}

.svg-disabled {
  color: #999 !important;
}

.popover-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: capitalize;
}

.popover-item:not(.popover-item-disabled):hover {
  background-color: #f5f5f5;
}

.filter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.filter-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
}

.filter-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-modal-header h2 {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.24px;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  /* 100% */
  letter-spacing: 0.18px;
}

.filter-content {
  margin-top: 24px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-section label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.18px;
  margin-bottom: 12px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

.date-input-container input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container svg {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-button,
.apply-button {
  padding: 12px 24px;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button {
  background: white;
  border: 1px solid #e8e8e8;
  color: #5c656c;
}

.apply-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.filter-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin-left: auto;
}

.filter-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.filter-section select {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  color: #32393e;
  background: white;
  cursor: pointer;
}

.date-picker {
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

:deep(.dp__input) {
  height: 40px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

:deep(.dp__clear_icon) {
  right: 10px;
}

:deep(.dp__input::placeholder) {
  color: #5c656c;
  opacity: 1;
}

:deep(.dp__menu) {
  font-family: Archivo;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
}

:deep(.dp__range_end),
:deep(.dp__range_start),
:deep(.dp__active_date) {
  background: var(--primary-color);
  color: white;
}

:deep(.dp__range_between) {
  background: rgba(22, 72, 99, 0.1);
  color: var(--primary-color);
}

.main-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.main-row:hover {
  background-color: rgba(22, 72, 99, 0.05);
}

.accordion-row {
  background-color: #c2c9cf !important;
}

.accordion-row td {
  /* padding: 12px 8px; */
  border-bottom: 1px solid #e8e8e8;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
}

.actions-menu {
  position: relative;
  display: inline-block;
  z-index: 10;
}

.actions-button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.actions-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.actions-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 4px 13.1px rgba(0, 0, 0, 0.1);
  z-index: 200000;
  min-width: 200px;
  padding: 8px 0;
}

.action-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  transition: background-color 0.2s;
}

.action-item:hover {
  background-color: #f5f5f5;
}

.action-item svg {
  width: 20px;
  height: 20px;
  color: var(--primary-color);
}

.action-item span {
  white-space: nowrap;
}

.truncate-cell {
  max-width: 150px;
  /* Reduced width */
  /* padding: 8px; */
  position: relative;
}

.tooltip-container {
  position: relative;
  width: 100%;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  word-break: normal;
  overflow-wrap: break-word;
}

.truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.truncate-text:hover {
  color: var(--primary-color);
}

/* Additional styles for accordion rows */
.accordion-row .truncate-cell {
  max-width: 150px;
  /* padding: 8px; */
  position: relative;
}

.accordion-row .tooltip-container {
  position: relative;
  width: 100%;
}

.accordion-row .tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  word-break: normal;
  overflow-wrap: break-word;
}

.accordion-row .tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.accordion-row .truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.accordion-row .truncate-text:hover {
  color: var(--primary-color);
}

.no-data-row {
  background-color: #f8f9fa;
}

.no-data-message {
  text-align: center;
  padding: 40px;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 100%;
}

.no-data-container h3 {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}

.no-data-container p {
  color: #5c656c;
  font-family: Archivo;
  font-size: 16px;
  margin: 0;
}

.jobCount {
  margin-left: auto;
  padding: 2px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  min-width: 40px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
}

.count-pending {
  background-color: #fff4de;
  color: #ffa800;
}

.count-completed {
  background-color: #e8fff3;
  color: #1bc5bd;
}

.count-failed {
  background-color: #ffe2e5;
  color: #f64e60;
}

.jobItem {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  position: relative;
}

.jobItemTitle {
  margin-right: 8px;
}

.searchInput {
  border: none;
  outline: none;
  width: 100%;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  color: #8f969b;
  /* text-align: left; */
}

/* .searchInput {
  padding: 8px 32px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  width: 200px;
} */

.resetButton {
  position: absolute;
  right: 30px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #8f969b;
}

.searchBar svg {
  /* position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%); */
}

td {
  overflow: visible !important;
}

.date-filter-chip {
  display: inline-flex;
  align-items: center;
  background-color: #f5f6f7;
  border-radius: 6px;
  padding: 6px 12px;
  margin-left: 12px;
  gap: 8px;
}

.date-filter-text {
  color: #5c656c;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.date-filter-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.date-filter-clear:hover {
  background-color: #e8e9ea;
}

.date-filter-clear svg {
  width: 16px;
  height: 16px;
}

.no-permission {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);
  color: var(--primary-color);
  font-family: Archivo;
}

.no-permission h2 {
  font-size: 24px;
  font-weight: 500;
}

.jobGridContainerAdmin {
  border-radius: 8px;
  background: #fff;
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 8px;
  height: calc(100vh - 350px);
}

.jobGridContainerUser {
  border-radius: 8px;
  background: #fff;
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 8px;
  height: calc(100vh - 265px);
}
</style>
